import React from "react";
import { NavLink } from "react-router-dom";
import Login from "../components/Login";
import { ROUTES } from "../routes/routes";
import "./css/LoginPage.css";

function LoginPage() {
  return (
    <div className="login-container">
      <div className="login-left-column">
        <div className="brand-container">
          <NavLink to={ROUTES.Home()} className="brand-title">
            <img src="/white_logo.png" alt="Render FM Logo" className="brand-logo" />
            <h1>Render FM</h1>
          </NavLink>
          <p className="brand-tagline">
            Taking Audio Visualisations up a notch
          </p>
        </div>
      </div>
      <div className="login-right-column">
        <div className="login-brand-header">
          <NavLink to={ROUTES.Home()} className="login-brand-title">
            <img src="/black_logo.png" alt="Render FM Logo" className="login-brand-logo" />
            Render FM
          </NavLink>
        </div>
        <div className="login-top-menu-mobile">
          <div className="login-top-menu-container">
            <NavLink to={ROUTES.Home()} className="login-top-menu-brand">
              <img src="/pink_logo.png" alt="Render FM Logo" className="login-mobile-logo" />
              Render FM
            </NavLink>
          </div>
        </div>
        <Login />
      </div>
    </div>
  );
}

export default LoginPage;
